"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.designPopup = void 0;
var utils_1 = require("../../utils");
exports.designPopup = function (axios) {
    return {
        getDesignPopups: function (request) {
            return axios.get('/design-popups', request);
        },
        postDesignPopups: function (request) {
            return axios.post('/design-popups', request.data);
        },
        deleteDesignPopups: function (request) {
            return axios.delete('/design-popups', request);
        },
        getDesignPopupsDisplayUrls: function (request) {
            return axios.get('/design-popups/display-urls', request);
        },
        postDesignPopupsDisplayUrls: function (request) {
            return axios.post('/design-popups/display-urls', request.data);
        },
        deleteDesignPopupsDisplayUrls: function (request) {
            return axios.delete('/design-popups/display-urls', request);
        },
        getDesignPopupsPopupNo: function (request) {
            var url = utils_1.paramPathchange('/design-popups/{popupNo}', request);
            return axios.get(url);
        },
        putDesignPopupsPopupNo: function (request) {
            var url = utils_1.paramPathchange('/design-popups/{popupNo}', request);
            return axios.put(url, request.data);
        },
        getDesignPopupsDisplayUrlsPlatforms: function (request) {
            return axios.get('/design-popups/display-urls/platforms', request);
        },
        getDesignPopupsDisplayUrlsPageNo: function (request) {
            var url = utils_1.paramPathchange('/design-popups/display-urls/{pageNo}', request);
            return axios.get(url);
        },
        putDesignPopupsPopupNoDisplayStatus: function (request) {
            var url = utils_1.paramPathchange('design-popups/{popupNo}/display-status', request);
            return axios.put(url, request.params);
        },
        getDesignPopupsPreviewPopupNo: function (request) {
            var url = utils_1.paramPathchange('design-popups/{popupNo}/preview', request);
            return axios.get(url);
        },
        getDesignPopupsDuplicate: function (request) {
            return axios.get('/design-popups/duplicate', request);
        },
        getDesignPopupsExcel: function (request) {
            return axios.get('/design-popups/excel', request);
        }
    };
};
